/* eslint-disable @khanacademy/ts-no-error-suppressions */
/* eslint-disable jsx-a11y/anchor-is-valid, react/sort-comp */
import {t} from "@lingui/core/macro";
import {css, StyleSheet} from "aphrodite";
import classNames from "classnames";
import gql from "graphql-tag";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {gqlOp, type GqlOperation} from "@repo/data-gql-core";
import {RequestInfo} from "@repo/shared-core";

import withApollo, {
    type WithApolloProps,
} from "#data-access/gql/with-apollo.tsx";
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedCheckbox from "#shared-components-package/deprecated-checkbox.tsx";
// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedLabeledField from "#shared-components-package/deprecated-labeled-field.tsx";
import KUITextArea from "#shared-components-package/labeled-textarea.tsx";

type SubmitStoryData = {
    submitStory: {
        success: boolean;
    };
};
type SubmitStoryVariables = {
    story: {
        email: string;
        level: string;
        role: string;
        shareAllowed: boolean;
        story: string;
        submitterName: string;
        videoUrl: string;
    };
};
const SUBMIT_STORY_MUTATION: GqlOperation<
    SubmitStoryData,
    SubmitStoryVariables
> = gqlOp(gql`
    mutation submitStory($story: SubmitStoryInput!) {
        submitStory(story: $story) {
            success
        }
    }
`);

type InnerOwnProps = {
    onClose: () => unknown;
};
type InnerProps = InnerOwnProps & WithApolloProps;
type InnerState = {
    story: string;
    video: string;
    name: string;
    email: string;
    role: string;
    level: string;
    shareable: boolean;
    submitting: boolean;
};

class StoryFormInnerImpl extends React.Component<InnerProps, InnerState> {
    state: InnerState = {
        story: "",
        video: "",
        name: "",
        email: "",
        role: "",
        level: "",
        shareable: false,
        submitting: false,
    };

    isCompleted = (): boolean => {
        return !!(
            (this.state.story || this.state.video) &&
            this.state.shareable
        );
    };

    isBlank = (): boolean => {
        return !(
            this.state.story ||
            this.state.video ||
            this.state.name ||
            this.state.email ||
            this.state.role ||
            this.state.level
        );
    };

    handleChange = (
        key: keyof InnerState,
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        const update: Partial<InnerState> = {};
        if (key === "shareable") {
            // @ts-expect-error - TS2339 - `checked` doesn't exist on HTMLTextAreaElement.
            update[key] = e.target.checked;
        } else {
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'undefined'.
            update[key] = e.target.value;
        }
        // @ts-expect-error - TS2345 - Argument of type 'Partial<InnerState>' is not assignable to parameter of type 'InnerState | ((prevState: Readonly<InnerState>, props: Readonly<InnerProps>) => InnerState | Pick<InnerState, keyof InnerState> | null) | Pick<...> | null'.
        this.setState(update);
    };

    handleWindowKeyDown = (e: KeyboardEvent) => {
        // Allow closing with Esc only if the form is blank
        if (e.keyCode === 27 /* Esc */ && this.isBlank()) {
            this.props.onClose();
        }
    };

    handleContentClick = (e: React.MouseEvent) => {
        // Close only if the user clicked on the overlay
        if (e.target === e.currentTarget && this.isBlank()) {
            this.props.onClose();
        }
    };

    handleSubmit = (e: React.SyntheticEvent) => {
        e.preventDefault();
        this.setState({submitting: true});

        const story = {
            email: this.state.email,
            level: this.state.level,
            role: this.state.role,
            shareAllowed: this.state.shareable,
            story: this.state.story,
            submitterName: this.state.name,
            videoUrl: this.state.video,
        } as const;

        this.props.gqlClient
            .mutate(SUBMIT_STORY_MUTATION, {
                variables: {story},
            })
            .then(this.props.onClose);
    };

    handleClose = (e: React.MouseEvent) => {
        e.preventDefault();
        this.props.onClose();
    };

    handleSelectRole = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({role: e.target.value});
    };

    render(): React.ReactNode {
        return (
            // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- TODO: Address a11y error
            <div
                className="story-form__content"
                onClick={this.handleContentClick}
            >
                <div className="story-form__page">
                    <div className="story-form__close">
                        <a
                            href="#"
                            onClick={this.handleClose}
                            role="button"
                            title={t`Close`}
                        >
                            &times;
                        </a>
                    </div>
                    <h2>{t`Share your story`}</h2>
                    {RequestInfo.kaLocale === "en" && (
                        <p className={css(styles.privacyCopy)}>
                            {t`We’re grateful for all of your stories, but please only share it if it is about you and you’re 13 years of age or over.`}
                        </p>
                    )}
                    <form>
                        <KUITextArea
                            autoFocus
                            title={t`How has Khan Academy changed your life?`}
                            value={this.state.story}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={this.handleChange.bind(null, "story")}
                            height="120px"
                        />
                        <DeprecatedLabeledField
                            type="text"
                            title={t`Your name`}
                            value={this.state.name}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={this.handleChange.bind(null, "name")}
                        />
                        <DeprecatedLabeledField
                            type="text"
                            title={t`Your email`}
                            value={this.state.email}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={this.handleChange.bind(null, "email")}
                        />
                        {RequestInfo.kaLocale === "en" && (
                            <p className={css(styles.privacyCopy)}>
                                {t`We may reach out to you and ask for your permission to share your story on our social media channels.`}
                            </p>
                        )}
                        <div
                            className={
                                "kui-labeledfield " +
                                css(styles.kuiLabeledFieldBase)
                            }
                        >
                            <div className={css(styles.kuiLabeledFieldTitle)}>
                                {t`I'm using Khan Academy as a`}
                            </div>
                            <div>
                                <select
                                    // @ts-expect-error - TS2322 - Type '(e: React.ChangeEvent<HTMLInputElement>) => void' is not assignable to type 'ChangeEventHandler<HTMLSelectElement>'.
                                    onChange={this.handleSelectRole}
                                    className={css(styles.select)}
                                >
                                    <option value="">{t`Select one`}</option>
                                    <option value="student">
                                        {t`Student`}
                                    </option>
                                    <option value="teacher">
                                        {t`Teacher`}
                                    </option>
                                    <option value="parent">{t`Parent`}</option>
                                    <option value="adult_learner">
                                        {t`Adult learner`}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <DeprecatedLabeledField
                            type="text"
                            title={t`Level in school`}
                            value={this.state.level}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={this.handleChange.bind(null, "level")}
                            placeholder={t`For example, 8th grade or Standard 8`}
                        />
                        <DeprecatedLabeledField
                            type="text"
                            title={t`Tell your story as a video`}
                            value={this.state.video}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={this.handleChange.bind(null, "video")}
                            placeholder={t`Optional - provide link to your video`}
                        />
                        <div style={{marginBottom: 10}}>
                            {RequestInfo.kaLocale === "en" && (
                                <label>
                                    <DeprecatedCheckbox
                                        checked={this.state.shareable}
                                        // eslint-disable-next-line react/jsx-no-bind
                                        onChange={this.handleChange.bind(
                                            null,
                                            "shareable",
                                        )}
                                    />{" "}
                                    {t`I am 13 years of age or older`}
                                </label>
                            )}
                            {RequestInfo.kaLocale !== "en" && (
                                <label>
                                    <DeprecatedCheckbox
                                        checked={this.state.shareable}
                                        // eslint-disable-next-line react/jsx-no-bind
                                        onChange={this.handleChange.bind(
                                            null,
                                            "shareable",
                                        )}
                                    />{" "}
                                    {t`Khan Academy can share my story publicly, and I am 13 years of age or older`}
                                </label>
                            )}
                        </div>
                        <Button
                            onClick={this.handleSubmit}
                            type="submit"
                            disabled={
                                this.state.submitting || !this.isCompleted()
                            }
                            style={{width: "100%"}}
                        >
                            {this.state.submitting ? t`Sending…` : t`Submit`}
                        </Button>
                    </form>
                </div>
            </div>
        );
    }

    componentDidMount() {
        window.addEventListener("keydown", this.handleWindowKeyDown, false);
    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.handleWindowKeyDown, false);
    }
}

const StoryFormInner = withApollo(StoryFormInnerImpl);

type StoryFormProps = {
    open: boolean;
    onClose: () => void;
};

class StoryForm extends React.Component<StoryFormProps> {
    handleClose: () => void = () => {
        this.props.onClose();
    };

    render(): React.ReactNode {
        let children = null;
        if (this.props.open) {
            // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'null'.
            children = (
                <div className={css(styles.modal)}>
                    <div key="overlay" className="stories-modal-overlay" />
                    <StoryFormInner key="content" onClose={this.handleClose} />
                </div>
            );
        }

        const className = classNames({
            "story-form": true,
            "story-form-open": this.props.open,
        });
        return <div className={className}>{children}</div>;
    }

    componentDidMount() {
        document.body?.classList.toggle("story-form-active", this.props.open);
    }

    componentDidUpdate() {
        document.body?.classList.toggle("story-form-active", this.props.open);
    }

    componentWillUnmount() {
        document.body?.classList.toggle("story-form-active", false);
    }
}

const styles = StyleSheet.create({
    kuiLabeledFieldBase: {
        lineHeight: 1.4,
        marginBottom: 20,
        minHeight: 50,
    },

    kuiLabeledFieldTitle: {
        color: "#777",
        cursor: "default",
        float: "left",
        fontSize: 14,
        fontWeight: "bold",
        textTransform: "uppercase",
        marginBottom: 5,
    },

    select: {
        width: 500,
        height: 37,
        lineHeight: 30,
        borderRadius: 4,
        background: "#fcfcfc",
        border: "1px solid #ccc",
        boxSizing: "border-box",
        clear: "both",
        padding: "8px",
        verticalAlign: "baseline",
        // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'FontFamily | undefined'.
        fontFamily: ["Proxima Nova", "Helvetica", "Corbel", "sans-serif"],
    },
    modal: {
        // This should have zindexModal
        zIndex: 1080,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    privacyCopy: {
        marginTop: -16,
    },
});

export default StoryForm;
